import { render, staticRenderFns } from "./TemplatesHeader.vue?vue&type=template&id=76e8b312&scoped=true&"
import script from "./TemplatesHeader.vue?vue&type=script&lang=js&"
export * from "./TemplatesHeader.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesHeader.vue?vue&type=style&index=0&id=76e8b312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8b312",
  null
  
)

export default component.exports